// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1AIuQ","icon":"_23rGo","textWrapper":"_2OqiA","title":"_2MMdA"};